import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon, SunIcon, MoonIcon } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
export function Navbar() {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const {
    theme,
    toggleTheme
  } = useTheme();
  const navLinks = [{
    path: '/',
    label: 'Startseite'
  }, {
    path: '/repertoire',
    label: 'Repertoire'
  }, {
    path: '/kontakt',
    label: 'Kontakt'
  }];
  const isActive = (path: string) => location.pathname === path;
  return <nav className="sticky top-0 z-50 bg-[var(--color-nav-bg)] backdrop-blur-sm border-b border-border-base" data-id="element-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-33">
        <div className="flex justify-between items-center h-16" data-id="element-34">
          <Link to="/" className="font-display text-2xl font-bold text-primary hover:text-accent transition-colors" data-id="element-35">
            Tuesday
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-36">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`text-sm font-medium transition-colors ${isActive(link.path) ? 'text-accent' : 'text-muted hover:text-primary'}`} data-id="element-37">
                {link.label}
              </Link>)}
            <button onClick={toggleTheme} className="p-2 rounded hover:bg-surface transition-colors" aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'} data-id="element-38">
              {theme === 'dark' ? <SunIcon size={20} className="text-muted" data-id="element-39" /> : <MoonIcon size={20} className="text-muted" data-id="element-40" />}
            </button>
            <Link to="/buchen" className="px-5 py-2 bg-accent text-[var(--color-text-inv)] font-medium rounded hover:bg-[var(--color-accent-solid-hover)] transition-colors" data-id="element-41">
              Tuesday buchen
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden text-primary hover:text-accent transition-colors" data-id="element-42">
            {mobileMenuOpen ? <XIcon size={24} data-id="element-43" /> : <MenuIcon size={24} data-id="element-44" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && <div className="md:hidden border-t border-border-base bg-base" data-id="element-45">
          <div className="px-4 py-4 space-y-3" data-id="element-46">
            {navLinks.map(link => <Link key={link.path} to={link.path} onClick={() => setMobileMenuOpen(false)} className={`block py-2 text-sm font-medium transition-colors ${isActive(link.path) ? 'text-accent' : 'text-muted hover:text-primary'}`} data-id="element-47">
                {link.label}
              </Link>)}
            <button onClick={toggleTheme} className="flex items-center gap-2 py-2 text-sm font-medium text-muted hover:text-primary transition-colors" data-id="element-48">
              {theme === 'dark' ? <SunIcon size={18} data-id="element-49" /> : <MoonIcon size={18} data-id="element-50" />}
              <span data-id="element-51">{theme === 'dark' ? 'Light Mode' : 'Dark Mode'}</span>
            </button>
            <Link to="/buchen" onClick={() => setMobileMenuOpen(false)} className="block w-full px-5 py-2 bg-accent text-[var(--color-text-inv)] font-medium rounded hover:bg-[var(--color-accent-solid-hover)] transition-colors text-center" data-id="element-52">
              Tuesday buchen
            </Link>
          </div>
        </div>}
    </nav>;
}